module.exports = __webpack_public_path__ + "static/media/pk_pump.7bfd376e.jpg";